import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/home/runner/_work/frontend/frontend/node_modules/css-loader/dist/runtime/api.js'
import '/home/runner/_work/frontend/frontend/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/home/runner/_work/frontend/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

window.customElements.define('owc-banner-teaser', wrap(Vue, () => import('~root/src/packages/BannerTeaser/src/BannerTeaser.vue?shadow')))

window.customElements.define('owc-business-unit', wrap(Vue, () => import('~root/src/packages/BusinessUnitSwitch/src/BusinessUnit.vue?shadow')))

window.customElements.define('owc-business-unit-switch', wrap(Vue, () => import('~root/src/packages/BusinessUnitSwitch/src/BusinessUnitSwitch.vue?shadow')))

window.customElements.define('owc-conditional-container', wrap(Vue, () => import('~root/src/packages/ConditionalContainer/src/ConditionalContainer.vue?shadow')))

window.customElements.define('owc-division-switcher', wrap(Vue, () => import('~root/src/packages/DivisionSwitcher/src/DivisionSwitcher.vue?shadow')))

window.customElements.define('owc-feature-box', wrap(Vue, () => import('~root/src/packages/FeatureBox/src/FeatureBox.vue?shadow')))

window.customElements.define('owc-feature-box-button', wrap(Vue, () => import('~root/src/packages/FeatureBox/src/FeatureBoxButton.vue?shadow')))

window.customElements.define('owc-feature-box-item', wrap(Vue, () => import('~root/src/packages/FeatureBox/src/FeatureBoxItem.vue?shadow')))

window.customElements.define('owc-contact-info', wrap(Vue, () => import('~root/src/packages/Footer/src/ContactInfo.vue?shadow')))

window.customElements.define('owc-footer', wrap(Vue, () => import('~root/src/packages/Footer/src/Footer.vue?shadow')))

window.customElements.define('owc-footer-content', wrap(Vue, () => import('~root/src/packages/Footer/src/FooterContent.vue?shadow')))

window.customElements.define('owc-legal-section', wrap(Vue, () => import('~root/src/packages/Footer/src/LegalSection.vue?shadow')))

window.customElements.define('owc-lower-footer', wrap(Vue, () => import('~root/src/packages/Footer/src/LowerFooter.vue?shadow')))

window.customElements.define('owc-move-to-top', wrap(Vue, () => import('~root/src/packages/Footer/src/MoveToTop.vue?shadow')))

window.customElements.define('owc-newsletter', wrap(Vue, () => import('~root/src/packages/Footer/src/Newsletter.vue?shadow')))

window.customElements.define('owc-site-map', wrap(Vue, () => import('~root/src/packages/Footer/src/SiteMap.vue?shadow')))

window.customElements.define('owc-site-map-section', wrap(Vue, () => import('~root/src/packages/Footer/src/SiteMapSection.vue?shadow')))

window.customElements.define('owc-social-section', wrap(Vue, () => import('~root/src/packages/Footer/src/SocialSection.vue?shadow')))

window.customElements.define('owc-generic-image', wrap(Vue, () => import('~root/src/packages/GenericImage/src/GenericImage.vue?shadow')))

window.customElements.define('owc-header', wrap(Vue, () => import('~root/src/packages/Header/src/Header.vue?shadow')))

window.customElements.define('owc-header-button', wrap(Vue, () => import('~root/src/packages/Header/src/HeaderButton.vue?shadow')))

window.customElements.define('owc-header-flyout', wrap(Vue, () => import('~root/src/packages/Header/src/HeaderFlyout.vue?shadow')))

window.customElements.define('owc-header-logo', wrap(Vue, () => import('~root/src/packages/Header/src/HeaderLogo.vue?shadow')))

window.customElements.define('owc-header-main-navigation', wrap(Vue, () => import('~root/src/packages/Header/src/HeaderMainNavigation.vue?shadow')))

window.customElements.define('owc-header-navigation-link', wrap(Vue, () => import('~root/src/packages/Header/src/HeaderNavigationLink.vue?shadow')))

window.customElements.define('owc-header-navigation-link-list', wrap(Vue, () => import('~root/src/packages/Header/src/HeaderNavigationLinkList.vue?shadow')))

window.customElements.define('owc-header-navigation-teaser', wrap(Vue, () => import('~root/src/packages/Header/src/HeaderNavigationTeaser.vue?shadow')))

window.customElements.define('owc-header-navigation-tool-list', wrap(Vue, () => import('~root/src/packages/Header/src/HeaderNavigationToolList.vue?shadow')))

window.customElements.define('owc-header-navigation-topic', wrap(Vue, () => import('~root/src/packages/Header/src/HeaderNavigationTopic.vue?shadow')))

window.customElements.define('owc-header-secondary-flyout', wrap(Vue, () => import('~root/src/packages/Header/src/HeaderSecondaryFlyout.vue?shadow')))

window.customElements.define('owc-language-switch', wrap(Vue, () => import('~root/src/packages/Header/src/LanguageSwitch.vue?shadow')))

window.customElements.define('owc-highlight', wrap(Vue, () => import('~root/src/packages/Highlight/src/Highlight.vue?shadow')))

window.customElements.define('owc-highlight-slider', wrap(Vue, () => import('~root/src/packages/Highlight/src/HighlightSlider.vue?shadow')))

window.customElements.define('owc-hotspot', wrap(Vue, () => import('~root/src/packages/Hotspot/src/Hotspot.vue?shadow')))

window.customElements.define('owc-hotspot-overlay', wrap(Vue, () => import('~root/src/packages/Hotspot/src/HotspotOverlay.vue?shadow')))

window.customElements.define('owc-hotspot-panorama', wrap(Vue, () => import('~root/src/packages/Hotspot/src/HotspotPanorama.vue?shadow')))

window.customElements.define('owc-hotspot-panorama-item', wrap(Vue, () => import('~root/src/packages/Hotspot/src/HotspotPanoramaItem.vue?shadow')))

window.customElements.define('owc-hotspot-sidepanel', wrap(Vue, () => import('~root/src/packages/Hotspot/src/HotspotSidepanel.vue?shadow')))

window.customElements.define('owc-hotspot-sidepanel-item', wrap(Vue, () => import('~root/src/packages/Hotspot/src/HotspotSidepanelItem.vue?shadow')))

window.customElements.define('owc-hotspot-simple', wrap(Vue, () => import('~root/src/packages/Hotspot/src/HotspotSimple.vue?shadow')))

window.customElements.define('owc-hotspot-simple-author-item', wrap(Vue, () => import('~root/src/packages/Hotspot/src/HotspotSimpleAuthorItem.vue?shadow')))

window.customElements.define('owc-hotspot-simple-item', wrap(Vue, () => import('~root/src/packages/Hotspot/src/HotspotSimpleItem.vue?shadow')))

window.customElements.define('owc-lightbox', wrap(Vue, () => import('~root/src/packages/Lightbox/src/Lightbox.vue?shadow')))

window.customElements.define('owc-loading', wrap(Vue, () => import('~root/src/packages/Loading/src/Loading.vue?shadow')))

window.customElements.define('owc-media-gallery', wrap(Vue, () => import('~root/src/packages/MediaGallery/src/MediaGallery.vue?shadow')))

window.customElements.define('owc-media-gallery-item', wrap(Vue, () => import('~root/src/packages/MediaGallery/src/MediaGalleryItem.vue?shadow')))

window.customElements.define('owc-media-slider', wrap(Vue, () => import('~root/src/packages/MediaSlider/src/MediaSlider.vue?shadow')))

window.customElements.define('owc-media-slider-item', wrap(Vue, () => import('~root/src/packages/MediaSlider/src/MediaSliderItem.vue?shadow')))

window.customElements.define('owc-next-best-activities', wrap(Vue, () => import('~root/src/packages/NextBestActivities/src/NextBestActivities.vue?shadow')))

window.customElements.define('owc-next-best-activities-item', wrap(Vue, () => import('~root/src/packages/NextBestActivities/src/NextBestActivitiesItem.vue?shadow')))

window.customElements.define('owc-overlay', wrap(Vue, () => import('~root/src/packages/Overlay/src/Overlay.vue?shadow')))

window.customElements.define('owc-simple-list', wrap(Vue, () => import('~root/src/packages/SimpleList/src/SimpleList.vue?shadow')))

window.customElements.define('owc-simple-list-item', wrap(Vue, () => import('~root/src/packages/SimpleList/src/SimpleListItem.vue?shadow')))

window.customElements.define('owc-simple-teaser', wrap(Vue, () => import('~root/src/packages/SimpleTeaser/src/SimpleTeaser.vue?shadow')))

window.customElements.define('owc-simple-teaser-item', wrap(Vue, () => import('~root/src/packages/SimpleTeaser/src/SimpleTeaserItem.vue?shadow')))

window.customElements.define('owc-slot-container', wrap(Vue, () => import('~root/src/packages/SlotContainer/src/SlotContainer.vue?shadow')))

window.customElements.define('owc-stage', wrap(Vue, () => import('~root/src/packages/Stage/src/Stage.vue?shadow')))

window.customElements.define('owc-stage-cta-buttons', wrap(Vue, () => import('~root/src/packages/Stage/src/StageCtaButtons.vue?shadow')))

window.customElements.define('owc-stage-image', wrap(Vue, () => import('~root/src/packages/Stage/src/StageImage.vue?shadow')))

window.customElements.define('owc-stage-price', wrap(Vue, () => import('~root/src/packages/Stage/src/StagePrice.vue?shadow')))

window.customElements.define('owc-store', wrap(Vue, () => import('~root/src/packages/Store/src/Store.vue?shadow')))

window.customElements.define('owc-subnavigation', wrap(Vue, () => import('~root/src/packages/Subnavigation/src/Subnavigation.vue?shadow')))

window.customElements.define('owc-subnavigation-arrow-button', wrap(Vue, () => import('~root/src/packages/Subnavigation/src/SubnavigationArrowButton.vue?shadow')))

window.customElements.define('owc-subnavigation-arrows', wrap(Vue, () => import('~root/src/packages/Subnavigation/src/SubnavigationArrows.vue?shadow')))

window.customElements.define('owc-subnavigation-cta-buttons', wrap(Vue, () => import('~root/src/packages/Subnavigation/src/SubnavigationCtaButtons.vue?shadow')))

window.customElements.define('owc-table', wrap(Vue, () => import('~root/src/packages/Table/src/Table.vue?shadow')))

window.customElements.define('owc-table-cell', wrap(Vue, () => import('~root/src/packages/Table/src/TableCell.vue?shadow')))

window.customElements.define('owc-table-detail', wrap(Vue, () => import('~root/src/packages/Table/src/TableDetail.vue?shadow')))

window.customElements.define('owc-tab-author', wrap(Vue, () => import('~root/src/packages/Tabs/src/TabAuthor.vue?shadow')))

window.customElements.define('owc-tab-item', wrap(Vue, () => import('~root/src/packages/Tabs/src/TabItem.vue?shadow')))

window.customElements.define('owc-tabs', wrap(Vue, () => import('~root/src/packages/Tabs/src/Tabs.vue?shadow')))

window.customElements.define('owc-tabs-builder', wrap(Vue, () => import('~root/src/packages/TabsBuilder/src/TabsBuilder.vue?shadow')))

window.customElements.define('owc-cta', wrap(Vue, () => import('~root/src/packages/TextMediaModule/src/Cta.vue?shadow')))

window.customElements.define('owc-text-block', wrap(Vue, () => import('~root/src/packages/TextMediaModule/src/TextBlock.vue?shadow')))

window.customElements.define('owc-text-media-module', wrap(Vue, () => import('~root/src/packages/TextMediaModule/src/TextMediaModule.vue?shadow')))

window.customElements.define('owc-tracking', wrap(Vue, () => import('~root/src/packages/Tracking/src/Tracking.vue?shadow')))

window.customElements.define('owc-validation-box', wrap(Vue, () => import('~root/src/packages/ValidationBox/src/ValidationBox.vue?shadow')))

window.customElements.define('owc-validation-box-wrapper', wrap(Vue, () => import('~root/src/packages/ValidationBox/src/ValidationBoxWrapper.vue?shadow')))

window.customElements.define('owc-vertical-navigation', wrap(Vue, () => import('~root/src/packages/VerticalNavigation/src/VerticalNavigation.vue?shadow')))

window.customElements.define('owc-player', wrap(Vue, () => import('~root/src/packages/VideoPlayer/src/Player.vue?shadow')))

window.customElements.define('owc-thumbnail', wrap(Vue, () => import('~root/src/packages/VideoPlayer/src/Thumbnail.vue?shadow')))

window.customElements.define('owc-video-player', wrap(Vue, () => import('~root/src/packages/VideoPlayer/src/VideoPlayer.vue?shadow')))

window.customElements.define('owc-wb-accordion', wrap(Vue, () => import('~root/src/packages/WbAccordion/src/WbAccordion.vue?shadow')))

window.customElements.define('owc-wb-accordion-item', wrap(Vue, () => import('~root/src/packages/WbAccordion/src/WbAccordionItem.vue?shadow')))

window.customElements.define('owc-wb-table', wrap(Vue, () => import('~root/src/packages/WbTable/src/WbTable.vue?shadow')))